/**
 * BolsaDeProfissionais.Api
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AnoExperienciaEnum } from '../model/anoExperienciaEnum';
// @ts-ignore
import { BooleanResponse } from '../model/booleanResponse';
// @ts-ignore
import { EstadoVagaEnum } from '../model/estadoVagaEnum';
// @ts-ignore
import { NivelHabilitacaoEnum } from '../model/nivelHabilitacaoEnum';
// @ts-ignore
import { RegimeTrabalhoEnum } from '../model/regimeTrabalhoEnum';
// @ts-ignore
import { TipoContratoEnum } from '../model/tipoContratoEnum';
// @ts-ignore
import { VagaCancelamentoDTO } from '../model/vagaCancelamentoDTO';
// @ts-ignore
import { VagaDTO } from '../model/vagaDTO';
// @ts-ignore
import { VagaListItemDTOICollectionVagaPagedResponse } from '../model/vagaListItemDTOICollectionVagaPagedResponse';
// @ts-ignore
import { VagaResponse } from '../model/vagaResponse';
// @ts-ignore
import { VagaTotalDisponivelListItemDTOResponse } from '../model/vagaTotalDisponivelListItemDTOResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class VagaService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration
  ) {
    super(basePath, configuration);
  }

  /**
   * @param vagaDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addVagaPost(
    vagaDTO?: VagaDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BooleanResponse>;
  public addVagaPost(
    vagaDTO?: VagaDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BooleanResponse>>;
  public addVagaPost(
    vagaDTO?: VagaDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BooleanResponse>>;
  public addVagaPost(
    vagaDTO?: VagaDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/AddVaga`;
    return this.httpClient.request<BooleanResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: vagaDTO,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteVagaByIdIdDelete(
    id: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BooleanResponse>;
  public deleteVagaByIdIdDelete(
    id: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BooleanResponse>>;
  public deleteVagaByIdIdDelete(
    id: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BooleanResponse>>;
  public deleteVagaByIdIdDelete(
    id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteVagaByIdIdDelete.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/DeleteVagaById/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'number',
      dataFormat: 'int32',
    })}`;
    return this.httpClient.request<BooleanResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param email
   * @param nome
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public enviarEmailPost(
    email?: string,
    nome?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public enviarEmailPost(
    email?: string,
    nome?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public enviarEmailPost(
    email?: string,
    nome?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public enviarEmailPost(
    email?: string,
    nome?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>email,
      'email'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>nome,
      'nome'
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/EnviarEmail`;
    return this.httpClient.request<any>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param pageNumber
   * @param pageSize
   * @param orderBy
   * @param EmpresaID
   * @param ProfissaoCatalogoID
   * @param especialidadeFuncaoID
   * @param hasVaga
   * @param codgoFuncao
   * @param designacaoFuncao
   * @param tipoContrato
   * @param nivelHabilitacao
   * @param anoExperiencia
   * @param regimeTrabalho
   * @param dataEncerramento
   * @param descricao
   * @param EstadoVaga
   * @param remuneracao
   * @param localizacao
   * @param codigo
   * @param dataInicio
   * @param dataFim
   * OrderBy?: string,
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllVagaGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    OrderBy?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<VagaListItemDTOICollectionVagaPagedResponse>;
  public getAllVagaGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    OrderBy?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<VagaListItemDTOICollectionVagaPagedResponse>>;
  public getAllVagaGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    OrderBy?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<VagaListItemDTOICollectionVagaPagedResponse>>;
  public getAllVagaGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    OrderBy?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>pageNumber,
      'PageNumber'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>pageSize,
      'PageSize'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>orderBy,
      'OrderBy'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>EmpresaID,
      'EmpresaID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>ProfissaoCatalogoID,
      'ProfissaoCatalogoID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>especialidadeFuncaoID,
      'EspecialidadeFuncaoID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>hasVaga,
      'HasVaga'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>codgoFuncao,
      'CodgoFuncao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>designacaoFuncao,
      'DesignacaoFuncao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>tipoContrato,
      'TipoContrato'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>nivelHabilitacao,
      'NivelHabilitacao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>anoExperiencia,
      'AnoExperiencia'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>regimeTrabalho,
      'RegimeTrabalho'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataEncerramento,
      'DataEncerramento'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>descricao,
      'Descricao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>EstadoVaga,
      'EstadoVaga'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>remuneracao,
      'Remuneracao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>localizacao,
      'Localizacao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>codigo,
      'Codigo'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataInicio,
      'DataInicio'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataFim,
      'DataFim'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>OrderBy,
      'OrderBy'
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/getAllVaga`;
    console.log(`${this.configuration.basePath}${localVarPath}`,'------');
    return this.httpClient.request<VagaListItemDTOICollectionVagaPagedResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVagaByIdIdGet(
    id: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<VagaResponse>;
  public getVagaByIdIdGet(
    id: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<VagaResponse>>;
  public getVagaByIdIdGet(
    id: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<VagaResponse>>;
  public getVagaByIdIdGet(
    id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling getVagaByIdIdGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/getVagaById/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'number',
      dataFormat: 'int32',
    })}`;
    return this.httpClient.request<VagaResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param vagaCancelamentoDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVagaCancelarPost(
    vagaCancelamentoDTO?: VagaCancelamentoDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BooleanResponse>;
  public getVagaCancelarPost(
    vagaCancelamentoDTO?: VagaCancelamentoDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BooleanResponse>>;
  public getVagaCancelarPost(
    vagaCancelamentoDTO?: VagaCancelamentoDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BooleanResponse>>;
  public getVagaCancelarPost(
    vagaCancelamentoDTO?: VagaCancelamentoDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/getVagaCancelar`;
    return this.httpClient.request<BooleanResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: vagaCancelamentoDTO,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param pageNumber
   * @param pageSize
   * @param orderBy
   * @param EmpresaID
   * @param ProfissaoCatalogoID
   * @param especialidadeFuncaoID
   * @param hasVaga
   * @param codgoFuncao
   * @param designacaoFuncao
   * @param tipoContrato
   * @param nivelHabilitacao
   * @param anoExperiencia
   * @param regimeTrabalho
   * @param dataEncerramento
   * @param descricao
   * @param EstadoVaga
   * @param remuneracao
   * @param localizacao
   * @param codigo
   * @param dataInicio
   * @param dataFim
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVagaTotalDisponivelGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<VagaTotalDisponivelListItemDTOResponse>;
  public getVagaTotalDisponivelGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<VagaTotalDisponivelListItemDTOResponse>>;
  public getVagaTotalDisponivelGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<VagaTotalDisponivelListItemDTOResponse>>;
  public getVagaTotalDisponivelGet(
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    EmpresaID?: number,
    ProfissaoCatalogoID?: number,
    especialidadeFuncaoID?: number,
    hasVaga?: boolean,
    codgoFuncao?: string,
    designacaoFuncao?: string,
    tipoContrato?: TipoContratoEnum,
    nivelHabilitacao?: NivelHabilitacaoEnum,
    anoExperiencia?: AnoExperienciaEnum,
    regimeTrabalho?: RegimeTrabalhoEnum,
    dataEncerramento?: string,
    descricao?: string,
    EstadoVaga?: EstadoVagaEnum,
    remuneracao?: number,
    localizacao?: string,
    codigo?: string,
    dataInicio?: string,
    dataFim?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>pageNumber,
      'PageNumber'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>pageSize,
      'PageSize'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>orderBy,
      'OrderBy'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>EmpresaID,
      'EmpresaID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>ProfissaoCatalogoID,
      'ProfissaoCatalogoID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>especialidadeFuncaoID,
      'EspecialidadeFuncaoID'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>hasVaga,
      'HasVaga'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>codgoFuncao,
      'CodgoFuncao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>designacaoFuncao,
      'DesignacaoFuncao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>tipoContrato,
      'TipoContrato'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>nivelHabilitacao,
      'NivelHabilitacao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>anoExperiencia,
      'AnoExperiencia'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>regimeTrabalho,
      'RegimeTrabalho'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataEncerramento,
      'DataEncerramento'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>descricao,
      'Descricao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>EstadoVaga,
      'EstadoVaga'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>remuneracao,
      'Remuneracao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>localizacao,
      'Localizacao'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>codigo,
      'Codigo'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataInicio,
      'DataInicio'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>dataFim,
      'DataFim'
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/getVagaTotalDisponivel`;
    return this.httpClient.request<VagaTotalDisponivelListItemDTOResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param vagaDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateVagaPut(
    vagaDTO?: VagaDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BooleanResponse>;
  public updateVagaPut(
    vagaDTO?: VagaDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BooleanResponse>>;
  public updateVagaPut(
    vagaDTO?: VagaDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BooleanResponse>>;
  public updateVagaPut(
    vagaDTO?: VagaDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'text/plain',
        'application/json',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/UpdateVaga`;
    return this.httpClient.request<BooleanResponse>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: vagaDTO,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }
}
